import { fetchJSON } from "./utils";

export function fetchDialects(params) {
  return fetchJSON("/api/dialects/", params, null, "get", false);
}

export function fetchDialectCapability(organizationId) {
  return fetchJSON("/api/dialects/capabilities", { organization_id: organizationId }, null, "get", false);
}

export function fetchLiveDialectsByThread(threadId, organizationId) {
  const params = { organization_id: organizationId };
  return fetchJSON(`/api/dialects/thread/${threadId}/live`, params, null, "get", false);
}

export function fetchDialectHistory(dialectId, organizationId) {
  return fetchJSON(
    `/api/dialects/${dialectId}/history`,
    { organization_id: organizationId },
    null,
    "get",
    false,
  );
}

export function fetchDialectHistoryByThread(threadId, organizationId) {
  const params = { organization_id: organizationId };
  return fetchJSON(`/api/dialects/thread/${threadId}/history`, params, null, "get", false);
}

export function deleteDialect(dialectId, data) {
  return fetchJSON(`/api/dialects/${dialectId}`, null, data, "delete");
}

export function restoreDialect(dialectId, data) {
  return fetchJSON(`/api/dialects/${dialectId}/restore`, null, data, "patch");
}
